let dtaPolygonsPromise;

function loadDtaPolygons() {
    if (!dtaPolygonsPromise) {
        dtaPolygonsPromise = window
            .fetch('dta/dta.geojson')
            .then((res) => res.json());
    }
    return dtaPolygonsPromise;
}

function featuresForDta(entityCode, dtaType) {
    return loadDtaPolygons().then((collection) => ({
        type: 'FeatureCollection',
        features: collection.features.filter((feature) => {
            const props = feature.properties || {};
            if (String(props.Entity_Code) !== String(entityCode)) {
                return false;
            }
            if (dtaType && props.DTA_Type !== dtaType) {
                return false;
            }
            return true;
        }),
    }));
}

function boundsForFeatures(features) {
    const bbox = [Infinity, Infinity, -Infinity, -Infinity];
    for (const feature of features) {
        expandBounds(bbox, feature.geometry);
    }
    if (!isFinite(bbox[0])) {
        return null;
    }
    return bbox;
}

function expandBounds(bbox, geometry) {
    if (!geometry) {
        return;
    }
    if (geometry.type === 'Polygon') {
        for (const ring of geometry.coordinates) {
            for (const [lng, lat] of ring) {
                bbox[0] = Math.min(bbox[0], lng);
                bbox[1] = Math.min(bbox[1], lat);
                bbox[2] = Math.max(bbox[2], lng);
                bbox[3] = Math.max(bbox[3], lat);
            }
        }
        return;
    }
    if (geometry.type === 'MultiPolygon') {
        for (const polygon of geometry.coordinates) {
            expandBounds(bbox, { type: 'Polygon', coordinates: polygon });
        }
        return;
    }
    if (geometry.type === 'LineString') {
        for (const [lng, lat] of geometry.coordinates) {
            bbox[0] = Math.min(bbox[0], lng);
            bbox[1] = Math.min(bbox[1], lat);
            bbox[2] = Math.max(bbox[2], lng);
            bbox[3] = Math.max(bbox[3], lat);
        }
    }
}

export { loadDtaPolygons, featuresForDta, boundsForFeatures };
